import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import "./fonts/Poppins-Regular.ttf";
import "./fonts/Poppins-Bold.ttf";
import "./fonts/Poppins-ExtraBold.ttf";
import AppStore from "./AppStore";
import WebsocketContextProvider from "./WebsocketContext";
import { MsalProvider } from "@azure/msal-react";
import "./components/subcomponents/Calendar.css";
import useSessionTracker from "./utils/useSessionTracker";
// import { useSelector } from 'react-redux';
import SessionTrackerWrapper from './SessionTrackerWrapper';
import AdminAnalyticsDashboard from './components/subcomponents/home/AdminAnalyticsDashboard';
import { initializeTrackingSystem } from './utils/userEventsLogger';

const App = ({ msalInstance }) => {
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <WebsocketContextProvider>
          <PayPalScriptProvider
            options={{
              locale: "en_US",
              currency: "EUR",
              clientId:
                "AQYWkzqV2IFpuR1miIUGWfDPynwUrYvMRRd_n6MLbr9Z-rmtdUqEzETrlrqDkbGYGXUocHlkbLtYrH7l", // live
            }}
          >
            <SessionTrackerWrapper />
            <div className="App">
              <AppStore />
            </div>
          </PayPalScriptProvider>
        </WebsocketContextProvider>
      </Provider>
    </MsalProvider>
  );
};

export default App;
